import { CollectionFile } from "../../../../shared/types/files";

/**
 * Adds a file to the picker's selection. `placedAfter` is how many of the files
 * already in the selection it belongs in front of, counted back from the end.
 */
export function insertSelectedFile<T extends CollectionFile>(
  selection: Map<string, T>,
  id: string,
  file: T,
  placedAfter?: number
): Map<string, T> {
  const position = placedAfter ? selection.size - placedAfter : -1;

  if (position < 0 || position >= selection.size) {
    return new Map(selection).set(id, file);
  }

  const next = new Map<string, T>();

  for (const [existingId, existing] of selection) {
    if (next.size === position) {
      next.set(id, file);
    }

    next.set(existingId, existing);
  }

  if (!next.has(id)) {
    next.set(id, file);
  }

  return next;
}
